<template>
  <div class="categorias-dnd">
    <base-header class="pb-4" v-if="!isMobile">
      <b-row align-v="center" class="py-4"></b-row>
    </base-header>
    <b-row class="pb-3">
      <b-col xl="4">
        <h6 class="h2 d-inline-block mb-0">Categorias de produto</h6>
      </b-col>
    </b-row>

    <!-- CATEGORIAS -->
    <div class="categorias-grid">
      <div
        v-for="cat in categorias"
        :key="cat.id"
        class="categoria-box"
        @dragover.prevent="!isMobile"
        @drop="!isMobile && onDrop(cat)"
      >
        <div class="categoria-title">
          <span>{{ cat.nome }}</span>
          <button
            class="edit-cat-btn"
            @click.stop="abrirEditarCategoria(cat)"
            title="Editar categoria"
          >
            ✏️
          </button>
        </div>

        <div
          v-for="p in cat.produtos.slice(0, MAX_VISIBLE)"
          :key="p.id"
          class="produto-tag"
          :class="{ selected: isSelected(p) }"
          :draggable="!isMobile"
          @click.stop="toggleSelect(p, $event)"
          @dragstart="!isMobile && onDragStart(p)"
        >
          {{ p.nome }}
          <span class="remove-btn" @click.stop="removerDaCategoria(p)">×</span>
        </div>

        <div
          v-if="cat.produtos.length > MAX_VISIBLE"
          class="ver-mais"
          @click="abrirCategoria(cat)"
        >
          + {{ cat.produtos.length - MAX_VISIBLE }} produtos
        </div>
      </div>

      <div
        v-if="categorias.length < 6"
        class="categoria-box categoria-add"
        @click="addCategoria"
      >
        + Adicionar categoria
      </div>
    </div>

    <!-- PRODUTOS SEM CATEGORIA -->
    <div class="produtos-livres">
      <div class="titulo">Produtos sem categoria</div>
      <div
        v-for="p in produtosLivres"
        :key="p.id"
        class="produto-tag"
        :class="{ selected: isSelected(p) }"
        :draggable="!isMobile"
        @click.stop="toggleSelect(p, $event)"
        @dragstart="!isMobile && onDragStart(p)"
      >
        {{ p.nome }}
      </div>
    </div>

    <!-- MODAL VER MAIS -->
    <div v-if="modalCategoria" class="modal-backdrop2">
      <div class="modal-box">
        <div class="modal-header">
          <strong>{{ modalCategoria.nome }}</strong>
          <span class="modal-close" @click="modalCategoria = null">×</span>
        </div>
        <div class="modal-body">
          <div
            v-for="p in modalCategoria.produtos"
            :key="p.id"
            class="produto-tag"
            :class="{ selected: isSelected(p) }"
            :draggable="!isMobile"
            @click.stop="toggleSelect(p, $event)"
            @dragstart="!isMobile && onDragStart(p)"
          >
            {{ p.nome }}
            <span class="remove-btn" @click.stop="removerDaCategoria(p)"
              >×</span
            >
          </div>
        </div>
      </div>
    </div>

    <!-- MOBILE ACTION BAR -->
    <div v-if="isMobile" class="mobile-actions">
      <div class="mobile-actions-info">
        <template v-if="selectedProducts.length">
          {{ selectedProducts.length }} selecionado<span
            v-if="selectedProducts.length > 1"
            >s</span
          >
        </template>
        <template v-else>Seleciona produtos</template>
      </div>
      <div class="mobile-actions-buttons">
        <button
          class="btn base-button btn-neutral"
          :disabled="!selectedProducts.length"
          @click="removerSelecionados"
        >
          Remover
        </button>
        <button
          class="btn btn-primary"
          :disabled="!selectedProducts.length"
          @click="showMover = true"
        >
          Mover
        </button>
      </div>
    </div>

    <!-- POPUP MOVER -->
    <div
      v-if="showMover"
      class="mover-backdrop"
      @click.self="showMover = false"
    >
      <div class="mover-modal">
        <div class="mover-header"><strong>Mover para categoria</strong></div>
        <div class="mover-body">
          <button
            v-for="cat in categorias"
            :key="cat.nome"
            class="btn btn-light mover-item"
            @click="moverSelecionados(cat)"
          >
            {{ cat.nome }}
          </button>
        </div>
        <div class="mover-footer">
          <button
            class="btn base-button btn-neutral"
            @click="showMover = false"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>

    <!-- MODAL EDITAR CATEGORIA -->
    <div v-if="categoriaEditar" class="modal-backdrop2">
      <div class="modal-box">
        <div class="modal-header">
          <strong>Editar categoria</strong>
          <span class="modal-close" @click="fecharEditarCategoria">×</span>
        </div>
        <div class="modal-body">
          <label class="mb-2 d-block">Nome da categoria</label>
          <input
            v-model="novoNomeCategoria"
            type="text"
            class="form-control"
            placeholder="Nome da categoria"
          />
        </div>
        <div class="modal-footer p-3 d-flex justify-content-end gap-2">
          <button
            class="btn btn-outline-secondary"
            @click="fecharEditarCategoria"
          >
            Cancelar
          </button>
          <button class="btn btn-primary" @click="guardarEditarCategoria">
            Guardar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { definicoesService } from "@/services";

  export default {
    name: "CategoriasDragDropBulk",
    data() {
      return {
        categorias: [],
        produtosLivres: [],
        categoriaEditar: null,
        novoNomeCategoria: "",
        selectedProducts: [],
        draggingProducts: [],
        MAX_VISIBLE: 6,
        modalCategoria: null,
        showMover: false,
      };
    },
    computed: {
      isMobile() {
        return window.innerWidth < 768;
      },
    },
    async mounted() {
      await this.carregarProdutosECategorias();
    },
    methods: {
      abrirEditarCategoria(cat) {
        this.categoriaEditar = cat;
        this.novoNomeCategoria = cat.nome;
      },
      fecharEditarCategoria() {
        this.categoriaEditar = null;
        this.novoNomeCategoria = "";
      },
      async guardarEditarCategoria() {
        if (!this.novoNomeCategoria.trim()) return;
        const antigoNome = this.categoriaEditar.nome;
        const novoNome = this.novoNomeCategoria.trim();
        this.categoriaEditar.nome = novoNome;
        this.categoriaEditar.id = novoNome;
        await definicoesService.renomearCategoria({
          categoria_antiga: antigoNome,
          categoria_nova: novoNome,
        });
        this.fecharEditarCategoria();
      },
      abrirCategoria(cat) {
        this.modalCategoria = cat;
      },
      async carregarProdutosECategorias() {
        const res = await definicoesService.getCategorias();
        const { categorias, produtos } = res;
        this.categorias = categorias.map((nome) => ({
          id: nome,
          nome,
          produtos: [],
        }));
        this.produtosLivres = [];
        produtos.forEach((p) => {
          const prod = { id: p.id, nome: p.nome };
          const cat = this.categorias.find((c) => c.nome === p.categoria);
          if (cat) cat.produtos.push(prod);
          else this.produtosLivres.push(prod);
        });
      },
      isSelected(prod) {
        return this.selectedProducts.includes(prod.id);
      },
      toggleSelect(prod, e) {
        if (!this.isMobile && !e.ctrlKey && !e.metaKey) {
          this.selectedProducts = [prod.id];
          return;
        }
        if (this.isSelected(prod))
          this.selectedProducts = this.selectedProducts.filter(
            (id) => id !== prod.id,
          );
        else this.selectedProducts.push(prod.id);
      },
      onDragStart(prod) {
        if (!this.isSelected(prod)) this.selectedProducts = [prod.id];
        this.draggingProducts = this.getAllProducts().filter((p) =>
          this.selectedProducts.includes(p.id),
        );
      },
      async onDrop(cat) {
        const produtos = [...this.draggingProducts];
        produtos.forEach((p) => {
          this.removeFromOrigin(p);
          cat.produtos.push(p);
        });
        this.clearSelection();
        await this.guardarCategoria(cat.nome, produtos);
      },
      async moverSelecionados(cat) {
        const produtos = this.getAllProducts().filter((p) =>
          this.selectedProducts.includes(p.id),
        );
        produtos.forEach((p) => {
          this.removeFromOrigin(p);
          cat.produtos.push(p);
        });
        await this.guardarCategoria(cat.nome, produtos);
        this.clearSelection();
        this.showMover = false;
      },
      async removerSelecionados() {
        const produtos = this.getAllProducts().filter((p) =>
          this.selectedProducts.includes(p.id),
        );
        for (const p of produtos) await this.removerDaCategoria(p);
        this.clearSelection();
      },
      async removerDaCategoria(prod) {
        this.removeFromOrigin(prod);
        this.produtosLivres.push(prod);
        await definicoesService.removerCategoria({ produtos: [prod.nome] });
      },
      async guardarCategoria(nome, produtos) {
        await definicoesService.categorizarProdutos({
          categoria: nome,
          produtos: produtos.map((p) => p.nome),
        });
      },
      getAllProducts() {
        return [
          ...this.produtosLivres,
          ...this.categorias.flatMap((c) => c.produtos),
        ];
      },
      removeFromOrigin(prod) {
        this.categorias.forEach(
          (c) => (c.produtos = c.produtos.filter((p) => p.id !== prod.id)),
        );
        this.produtosLivres = this.produtosLivres.filter(
          (p) => p.id !== prod.id,
        );
      },
      clearSelection() {
        this.selectedProducts = [];
        this.draggingProducts = [];
      },
      addCategoria() {
        const nome = prompt("Nome da categoria");
        if (nome && this.categorias.length < 6)
          this.categorias.push({ id: nome, nome, produtos: [] });
      },
    },
  };
</script>

<style scoped>
  .categorias-dnd {
    padding: 20px 24px;
    font-family: "DM Sans", "Outfit", system-ui, sans-serif;
  }

  /* GRID */
  .categorias-grid {
    display: grid;
    width: 100%;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    gap: 14px;
    margin-bottom: 28px;
  }

  /* CATEGORIA BOX */
  .categoria-box {
    border: 1.5px solid #f0ece8;
    border-radius: 14px;
    padding: 14px;
    min-height: 160px;
    background: #fff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04), 0 4px 12px rgba(0, 0, 0, 0.04);
    transition: border-color 0.15s, box-shadow 0.15s;
  }
  .categoria-box:hover {
    border-color: #e0d8d0;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06), 0 6px 18px rgba(0, 0, 0, 0.06);
  }

  .categoria-title {
    font-size: 13px;
    font-weight: 700;
    color: #1a1210;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    letter-spacing: -0.1px;
  }

  /* ADICIONAR */
  .categoria-add {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #b0a8a0;
    font-weight: 500;
    font-size: 13.5px;
    border: 1.5px dashed #e0d8d0;
    transition: all 0.15s;
  }
  .categoria-add:hover {
    border-color: #ff825d;
    color: #ff825d;
    background: #fff8f5;
    box-shadow: none;
  }

  /* TAGS */
  .produto-tag {
    display: inline-block;
    padding: 5px 24px 5px 10px;
    margin: 3px;
    background: #f5f2ef;
    border: 1px solid #ece8e4;
    border-radius: 8px;
    font-size: 12.5px;
    font-weight: 500;
    color: #3a3430;
    cursor: grab;
    user-select: none;
    position: relative;
    transition: background 0.12s, border-color 0.12s;
  }
  .produto-tag:hover {
    background: #ede9e5;
    border-color: #ddd8d2;
  }
  .produto-tag:active {
    cursor: grabbing;
  }

  .produto-tag.selected {
    background: #ff825d;
    border-color: #ff825d;
    color: #fff;
  }

  /* BOTÃO REMOVER */
  .remove-btn {
    position: absolute;
    top: 50%;
    right: 6px;
    transform: translateY(-50%);
    width: 16px;
    height: 16px;
    border-radius: 4px;
    background: rgba(0, 0, 0, 0.1);
    color: #5a4f48;
    font-size: 13px;
    line-height: 16px;
    text-align: center;
    cursor: pointer;
    display: none;
  }
  .produto-tag:hover .remove-btn {
    display: block;
  }
  .produto-tag.selected .remove-btn {
    background: rgba(255, 255, 255, 0.25);
    color: #fff;
  }
  .remove-btn:hover {
    background: rgba(0, 0, 0, 0.2) !important;
  }

  /* VER MAIS */
  .ver-mais {
    display: inline-block;
    margin: 3px;
    padding: 4px 10px;
    font-size: 11.5px;
    font-weight: 600;
    color: #ff825d;
    cursor: pointer;
    border-radius: 6px;
    transition: background 0.12s;
  }
  .ver-mais:hover {
    background: #fff0eb;
    text-decoration: none;
  }

  /* PRODUTOS LIVRES */
  .produtos-livres {
    border-top: 1px solid #f0ece8;
    padding-top: 20px;
  }
  .produtos-livres .titulo {
    font-size: 13px;
    font-weight: 700;
    color: #1a1210;
    margin-bottom: 10px;
    letter-spacing: -0.1px;
  }

  /* EDIT BTN */
  .edit-cat-btn {
    border: none;
    background: transparent;
    cursor: pointer;
    color: #c8c0b8;
    padding: 3px 5px;
    border-radius: 5px;
    font-size: 12px;
    line-height: 1;
    transition: all 0.12s;
    opacity: 0;
  }
  .categoria-title:hover .edit-cat-btn {
    opacity: 1;
  }
  .edit-cat-btn:hover {
    background: #f5f2ef;
    color: #ff825d;
  }

  /* MODAL VER MAIS / EDITAR */
  .modal-backdrop2 {
    position: fixed;
    inset: 0;
    background: rgba(15, 10, 8, 0.45);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99999999;
  }
  .modal-box {
    background: #fff;
    border-radius: 16px;
    width: 520px;
    max-width: calc(100vw - 32px);
    max-height: 70vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18);
  }
  .modal-header {
    padding: 16px 20px;
    border-bottom: 1px solid #f0ece8;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 15px;
    font-weight: 700;
    color: #1a1210;
  }
  .modal-body {
    padding: 14px 16px;
    overflow-y: auto;
  }
  .modal-close {
    cursor: pointer;
    font-size: 18px;
    color: #b0a8a0;
    line-height: 1;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 7px;
    transition: all 0.12s;
  }
  .modal-close:hover {
    background: #f5f2ef;
    color: #3a3430;
  }

  /* MOVER MODAL */
  .mover-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(15, 10, 8, 0.45);
    backdrop-filter: blur(4px);
    z-index: 9999999;
    display: flex;
    align-items: flex-end;
  }
  .mover-modal {
    background: #fff;
    width: 100%;
    border-radius: 18px 18px 0 0;
    padding: 20px 16px calc(20px + env(safe-area-inset-bottom));
    animation: slideUp 0.22s cubic-bezier(0.22, 0.68, 0, 1.2);
    box-shadow: 0 -8px 40px rgba(0, 0, 0, 0.12);
  }
  .mover-header {
    font-size: 15px;
    font-weight: 700;
    color: #1a1210;
    margin-bottom: 14px;
  }
  .mover-body {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
  .mover-item {
    text-align: left;
    font-weight: 500;
    font-size: 14px;
    padding: 12px 16px;
    border-radius: 10px;
    background: #f7f4f1 !important;
    border: 1px solid #ede9e5 !important;
    color: #1a1210 !important;
    transition: all 0.12s;
    width: 100%;
  }
  .mover-item:hover {
    background: #f0ece8 !important;
    border-color: #e0d8d0 !important;
  }
  .mover-footer {
    margin-top: 10px;
  }
  @keyframes slideUp {
    from {
      transform: translateY(100%);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  /* MOBILE ACTION BAR */
  .mobile-actions {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    border-top: 1px solid #f0ece8;
    padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 1050;
    box-shadow: 0 -6px 24px rgba(0, 0, 0, 0.08);
  }
  .mobile-actions-info {
    font-weight: 600;
    font-size: 14px;
    color: #1a1210;
  }
  .mobile-actions-buttons {
    display: flex;
    gap: 8px;
  }
  .mobile-actions .btn {
    min-height: 40px;
    padding-inline: 16px;
    border-radius: 10px;
    font-weight: 600;
  }
  .mobile-actions .btn:disabled {
    opacity: 0.4;
    pointer-events: none;
  }
</style>
